import { Common } from '../common';
import type {
  FileDocument,
  OrganizationDocument,
} from '../models/predict/document';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async embedAndStoreFiles(
    args:
      | { files: FileDocument[]; organizationId: string }
      | { files: FileDocument[]; documentClassName: string },
  ) {
    const url = this.common.constructPath(
      `/predict/documents/text/embed-and-store-files`,
    );
    return this.common.postJSON(url, args);
  }

  async createFilesForClassname(
    classname: string,
    files: FileDocument[],
  ): Promise<{ uuids: string[] }> {
    const url = this.common.constructPath(
      `/predict/documents/text/classnames/${classname}/documents`,
    );
    return this.common.postJSON(url, { files });
  }

  async findAllFilesByClassname(args: {
    classname: string;
    chunked?: boolean;
  }): Promise<OrganizationDocument[]> {
    const { classname, chunked } = args;
    const url = this.common.constructPath(
      `/predict/documents/text/classnames/${classname}/documents`,
      { chunked },
    );
    const { documents } = await this.common.getJSON(url);
    return documents;
  }

  async findFileByClassnameAndId(
    classname: string,
    id: string,
  ): Promise<OrganizationDocument> {
    const url = this.common.constructPath(
      `/predict/documents/text/classnames/${classname}/documents/${id}`,
    );
    return this.common.getJSON(url);
  }

  async updateFileForClassnameById(args: {
    classname: string;
    id: string;
    values: Pick<OrganizationDocument, 'url' | 'allowExternal'>;
  }): Promise<OrganizationDocument> {
    const { classname, id, values } = args;
    const url = this.common.constructPath(
      `/predict/documents/text/classnames/${classname}/documents/${id}`,
    );
    return this.common.patchJSON(url, values);
  }

  async deleteFileForClassnameById(args: {
    classname: string;
    id: string;
    collated?: boolean;
  }): Promise<{ success: true }> {
    const { classname, id, collated } = args;
    const url = this.common.constructPath(
      `/predict/documents/text/classnames/${classname}/documents/${id}`,
      { collated },
    );
    return this.common.deleteJSON(url);
  }
}
